import Api from "./api";

class CogenEventApi extends Api {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "co_gen_events/";
	}

	getCoGenEvents(facility, local_date, onSuccess, onError) {
		let endPoint =
			this.baseUrl + `?facility=${facility.split("/").slice(-2)[0]}`;
		if (local_date)
			endPoint =
				endPoint + "&local_date=" + local_date.toISOString().split("T")[0];

		this.Get(endPoint, onSuccess, onError);
	}
}

export default CogenEventApi;
